<template>
    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 10.4255L11.017 12.85L9.951 8.2805L13.5 5.206L8.8265 4.803L7 0.5L5.1735 4.803L0.5 5.206L4.0425 8.2805L2.983 12.85L7 10.4255Z" fill="currentColor"/>
    </svg>
</template>

<script>
export default {
    name: "StarFilled"
};
</script>
